import * as React from "react";
import { Formik } from "formik";
import FormInner from "./FormInner";

const Form = React.forwardRef(
  (
    {
      children,
      action,
      form,
      disabled,
      className,
      style,
      onValuesChange,
      ...restProps
    },
    ref
  ) => {
    return (
      <Formik {...restProps}>
        <FormInner
          form={form}
          ref={ref}
          onValuesChange={onValuesChange}
          disabled={disabled}
          action={action}
          className={className}
          style={style}
        >
          {children}
        </FormInner>
      </Formik>
    );
  }
);

export default Form;
